module.exports = __webpack_public_path__ + "assets/droplet-confirm.49fd67c2.svg";